import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { bolsas_diretor_unidade, bolsas_diretor_unidade_novos, bolsas_diretor_unidade_renovados } from "../../services/api";

import './detalhamento_bolsa.css';

const Bolsa_diretor_unidade = (props) => {

    const [data2, setData2] = useState([]);
    const [dataN, setDataN] = useState([]);
    const [dataR, setDataR] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    let data_inicio = props.di;
    let data_fim = props.df;
    let cod_unidade = props.un;

    const fetchData = async () => {
        try {
            const response = await bolsas_diretor_unidade(data_inicio, data_fim);
            setData2(response);
            const responseN = await bolsas_diretor_unidade_novos(data_inicio, data_fim);
            setDataN(responseN);
            const responseR = await bolsas_diretor_unidade_renovados(data_inicio, data_fim);
            setDataR(responseR);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {

        fetchData();
    }, [data_inicio, data_fim]);

    let chartBoldirUni = [];

    if (typeof data2 !== 'undefined') {

        const dadosFiltrados = data2.filter(item => item.sec === cod_unidade);
        chartBoldirUni = dadosFiltrados.map((item, index) => {

            if (item.sec === cod_unidade) {
                const row = ["Diretor"];
                row.push(parseFloat(item.round));
                return row;
            }
        });
        if (chartBoldirUni.length === 0) {
            chartBoldirUni.push(["Diretor", 0]);
        }

        chartBoldirUni.unshift(["Label", "Value"]);
    };

    let chartBoldirUniN = [];

    if (typeof dataN !== 'undefined') {

        const dadosFiltradosN = dataN.filter(item => item.sec === cod_unidade);
        chartBoldirUniN = dadosFiltradosN.map((item, index) => {

            if (item.sec === cod_unidade) {
                const row = ["Diretor N"];
                row.push(parseFloat(item.round));
                return row;
            }
        });
        if (chartBoldirUniN.length === 0) {
            chartBoldirUniN.push(["Diretor N", 0]);
        }

        chartBoldirUniN.unshift(["Label", "Value"]);
    };
    let chartBoldirUniR = [];

    if (typeof dataR !== 'undefined') {

        const dadosFiltradosR = dataR.filter(item => item.sec === cod_unidade);
        chartBoldirUniR = dadosFiltradosR.map((item, index) => {

            if (item.sec === cod_unidade) {
                const row = ["Diretor R"];
                row.push(parseFloat(item.round));
                return row;
            }
        });
        if (chartBoldirUniR.length === 0) {
            chartBoldirUniR.push(["Diretor R", 0]);
        }

        chartBoldirUniR.unshift(["Label", "Value"]);
    };



    const options = {
        width: 120, height: 120,
        redFrom: 33, redTo: 66,
        yellowFrom: 24, yellowTo: 33,
        minorTicks: 5,
        max: 66,
        min: 0
    };


    return (
        <div className="bolsasMU">
            <center>

                Bolsa Média tipo Diretor
                <Chart
                    chartType="Gauge"
                    version="current"
                    width="120px"
                    height="120px"
                    data={chartBoldirUni}
                    options={options}
                />
                Bolsa Média tipo Diretor Alunos Novos
                <Chart
                    chartType="Gauge"
                    version="current"
                    width="120px"
                    height="120px"
                    data={chartBoldirUniN}
                    options={options}
                />
                Bolsa Média tipo Diretor Alunos Renovados
                <Chart
                    chartType="Gauge"
                    version="current"
                    width="120px"
                    height="120px"
                    data={chartBoldirUniR}
                    options={options}
                />
            </center>
        </div>
    );
};
export default Bolsa_diretor_unidade;
